import React from 'react';
import './Pages.css';

const ProductManagement = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Product Management</h1>
        <p>Manage your product catalog</p>
      </div>
      <div className="page-content">
        <p>Product management content goes here...</p>
      </div>
    </div>
  );
};

export default ProductManagement;